import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { useEffect, useMemo, useRef } from "react";
import ReactPlayer from "react-player";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import {
  TEModal,
  TEModalDialog,
  TEModalContent,
  TEModalHeader,
  TEModalBody,
  TEModalFooter,
} from "tw-elements-react";
import { TERipple } from "tw-elements-react";
import { CiCompass1, CiMobile1, CiSliderHorizontal } from "react-icons/ci";

import { getEliteConnections } from "../../../api-services/api-query/connection-requests/useFetchConnections";
import EliteLayout from "../../../app-layouts/EliteLayout";
import { ELITELINKS } from "../../../app-routes/links";
import { APP_STORAGE, getUser } from "../../../api-services/process";
import Preloader from "../../../app-components/preloader/Preloader";
import { errorAlert, successAlert } from "../../../app-util/SweetAlert";
import apiClient from "../../../api-services/ApiClient";
import { Loading, SocialConnect } from "../../../assets/img";
import { useInterest } from "../../../api-services/api-query/Interest/useInterests";
import { inputStyle } from "../../../app-util/helpers";
import { UserProfileInterface } from "../../../app-schemas/user.interface";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDDMbSNBDGtP9FEtBdQ2eg0gXy_6wsPPy4",
  authDomain: "honeconnect-2885d.firebaseapp.com",
  projectId: "honeconnect-2885d",
  storageBucket: "honeconnect-2885d.firebasestorage.app",
  messagingSenderId: "345074710512",
  appId: "1:345074710512:web:1432c78dda056b20e0cf35",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// ✅ Register service worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (registrations.length > 1) {
      console.log(registrations);
      console.log(
        `Found ${registrations.length} service workers. Cleaning up...`,
      );

      // Keep only the last registered service worker (assuming latest is last in array)
      registrations.forEach((reg, index) => {
        if (index < registrations.length - 1) {
          reg
            .unregister()
            .then(() => console.log("Unregistered old service worker"));
        }
      });
    }

    // Ensure at least one valid service worker is registered
    if (registrations.length === 0) {
      // Only register if no service worker is active
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("Service Worker registered:", registration);
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });

      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => console.log("Active SWs:", regs.length));
    } else {
      console.log("Service Worker already registered.");
    }
  });
}

// Function to get the FCM token
export const requestForToken = async (): Promise<string | null> => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BPkujkHvUbcpi9z51dNJ-mhyT4C8kHmRDamtqI838wrhxwGtPvrKkh7JPWO1MvkHEVAoxzkU4xtUp3hWhP9g4Zo",
      });
      return token;
    } else {
      console.error("Permission not granted");
      return null;
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null;
  }
};

// Define your default filter structure
const defaultFilters = {
  country_id: null,
  state_id: null,
  city_id: null,
  date_range: null,
  interest_id: null,
  gender: null,
};

const FILTER_STORAGE_KEY = "hone-filters";

const EliteHomePage = () => {
  const user: UserProfileInterface = getUser();
  const ads = [
    "1.jpeg",
    "2.jpeg",
    "3.jpeg",
    "4.jpeg",
    "5.jpeg",
    "6.jpeg",
    "7.jpeg",
    "8.jpeg",
    "9.jpeg",
    "10.jpeg",
    "11.jpeg",
    "12.jpeg",
    
  ];
  
  const navigate = useNavigate();
  const { ref, inView } = useInView();
  const [laoding, setLoading] = useState(false);
  const [scrollDirection, setScrollDirection] = useState<string | null>(null);
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
  const [showModal, setShowModal] = useState(false);
  const [showAutoRequestModal, setShowAutoRequestModal] = useState(false);
  const interestData = useInterest();

  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  // const [notification, setNotification] = useState<{ title: string; body: string } | null>(null);
  const videoRefs = useRef<{ [key: string]: ReactPlayer | null }>({});

  const handlePlay = (uuid: string) => {
    // Pause all other videos except the one that started playing
    Object.entries(videoRefs.current).forEach(([key, player]) => {
      if (key !== uuid && player) {
        player.seekTo(0, "seconds"); // Reset video to start (optional)
        player.getInternalPlayer()?.pause(); // Pause the video
      }
    });
  };

  // Filters state
  const [filters, setFilters] = useState(() => {
    // Load from localStorage on initial mount
    const saved = localStorage.getItem(FILTER_STORAGE_KEY);
    return saved ? JSON.parse(saved) : defaultFilters;
  });

  useEffect(() => {
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));
  }, [filters]);

  // firebase trigger
  useEffect(() => {
    requestForToken().then((token) => {
      if (token) {
        storeFCMToken(token);
      }
    });

    // eslint-disable-next-line
  }, []);

  const storeFCMToken = async (token: string) => {
    try {
      const data = { fcm_token: token, user_id: user.id };
      await apiClient.post("update-fcm-token", data);
    } catch (err) {
      console.log("error in storing FCM token");
    }
  };

  useEffect(() => {
    handleCountries();
  }, []);

  useEffect(() => {
    const modalStatus = localStorage.getItem("AUTO_REQUEST_MODAL");

    if (modalStatus !== "dismissed" && Number(user?.is_phone_verified) !== 1) {
      setShowAutoRequestModal(true);
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const countryId = filters?.country_id;

    if (user?.country_id?.toString() !== countryId) {
      setFilters((prevState: any) => ({
        ...prevState,
        city_id: null,
        state_id: null,
      }));

      setStates([]);
      setCities([]);
    }

    if (countryId) handleStates(Number(countryId) ?? 0);
  }, [filters?.country_id, user?.country_id]);

  useEffect(() => {
    const stateId = filters?.state_id;
    if (stateId) handleCities(Number(stateId) ?? 0);
  }, [filters?.state_id]);

  const filterInterest = (data: any) => {
    if (data) {
      const uniqueInterests = new Map();

      data.forEach((item: any) => {
        const interest = item.interest;
        uniqueInterests.set(interest.id, interest);
      });
      const interestsArray = Array.from(uniqueInterests.values());

      return interestsArray;
    }

    return [];
  };

  const memoizedFilters = useMemo(() => filters, [filters]);

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useInfiniteQuery({
      queryKey: ["all_connections", memoizedFilters],
      queryFn: async ({ pageParam = 1 }) =>
        getEliteConnections({ ...memoizedFilters, page: pageParam }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) =>
        lastPage.currentPage < lastPage.totalPages
          ? lastPage.currentPage + 1
          : undefined,
    });

  // handle-input-change
  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | any
    >,
  ) => {
    console.log(e);
    const { name, value } = e.target;
    setFilters((prevState: any) => ({
      ...prevState,
      [name]: value ? value : null,
    }));
  };

  const handleCheckBox = (key: any, value: any) => {
    setFilters((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleCheckBoxInterest = (name: string, value: number) => {
    if (value === null) {
      setFilters((prevState: any) => ({
        ...prevState,
        [name]: value,
      }));
    }

    setFilters((prevFilters: any) => {
      // Check if the value is already in the array
      const interestIds = prevFilters[name] || [];
      const updatedIds = interestIds.includes(value)
        ? interestIds.filter((id: number) => id !== value) // Remove if already selected
        : [...interestIds, value]; // Add if not selected

      return {
        ...prevFilters,
        [name]: updatedIds,
      };
    });
  };

  const clearFilter = () => {
    setFilters({
      country_id: null,
      state_id: null,
      city_id: null,
      date_range: null,
      interest_id: null,
      gender: null,
    });
  };

  const getImageSrc = (post: any) => {
    if (post?.caption_image)
      return `${APP_STORAGE}gallery_pictures/${post.caption_image}`;
    else if (post?.user?.profile_picture)
      return `${APP_STORAGE}${post.user.profile_picture}`;
    return "img/PrivateAccount.png";
  };

  // const getBadgeSrc = (badge: string) => {
  //   switch (badge) {
  //     case "GOLD":
  //       return "img/gold-medal.png";
  //     case "SILVER":
  //       return "img/gold-medal-2.png";
  //     default:
  //       return "";
  //   }
  // };

  const handleConnect = async (uuid: any) => {
    if (!uuid) return;

    const data = {
      connection_request_id: uuid,
    };

    try {
      setLoading(true);
      const res = await apiClient.post("elite-requests-responses", data);
      successAlert();

      if (res.data.status) {
        navigate(ELITELINKS.MY_RESPONSES);
      }
    } catch (error: any) {
      if (error.match("NO_PLAN")) {
        navigate(`${ELITELINKS.SUBSCRIPTIONS}/${uuid}`);
      } else if (error.match("You have already responded")) {
        navigate(ELITELINKS.MY_RESPONSES);
      } else {
        errorAlert(JSON.stringify(error), 20000);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCountries = async () => {
    // setPageLoading(true);
    try {
      const res: any = await apiClient.get("countries");
      setCountries(res.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      errorAlert("");
    } finally {
      // setPageLoading(false);
    }
  };

  const handleStates = async (country: number) => {
    // setPageLoading(true);
    try {
      const res: any = await apiClient.get(`countries/${country}/states`);
      setStates(res.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      errorAlert("");
    } finally {
      // setPageLoading(false);
    }
  };

  const handleCities = async (state: number) => {
    // setPageLoading(true);
    try {
      const res: any = await apiClient.get(`states/${state}/cities`);
      setCities(res.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      errorAlert("");
    } finally {
      // setPageLoading(false);
    }
  };

  const isVideo = (post: any): boolean => {
    // Define a list of common video file extensions
    const videoExtensions = [
      ".mp4",
      ".mov",
      ".avi",
      ".mkv",
      ".webm",
      ".flv",
      ".wmv",
    ];

    // Extract the file extension in lowercase
    const fileExtension = post?.caption_image
      ?.toLowerCase()
      .slice(post?.caption_image.lastIndexOf("."));

    // Check if the file extension is in the list of video extensions
    return videoExtensions.includes(fileExtension);
  };

  const donotShowAutoRequestModal = () => {
    localStorage.setItem("AUTO_REQUEST_MODAL", "dismissed");
    setShowAutoRequestModal(false);
  };

  const connectionComponent = useMemo(
    () => {
      const random_img = Math.floor(Math.random() * 8);

      if (!data || data.pages.length === 0 || data.pages[0].data.length === 0) {
        return (
          <div className="text-center text-gray-500 dark:text-gray-200 dark:bg-slate-700 mt-[25vh]">
            <p className="mb-5 text-sm">No connection is available</p>
            <Link
              className="bg-honeConnectPurple dark:bg-slate-800 dark:text-gray-300 py-2 px-5 border text-white shadow rounded-lg"
              to={ELITELINKS.MAKE_REQUEST}
            >
              Make a request
            </Link>
          </div>
        );
      }

      const elements: JSX.Element[] = [];

      elements.push(
        <div className="w-full min-h-[350px] mt-[0px] my-4 p-4 bg- text-center rounded-lg mb-0">
          <img
            src={`../sliders/${ads[random_img]}`}
            alt="Display"
            className="w-full rounded-xl bg-gray-100 dark:bg-slate-700"
          />
        </div>,
      );

      data?.pages.forEach((page) => {
        page.data.forEach((post: any, index: number) => {
          // Push the actual post card
          elements.push(
            <div
              key={post.uuid}
              ref={index === 5 ? ref : undefined}
              className="w-full flex flex-col gap-1 bg-white dark:bg-slate-800 lg:rounded-10px sm:mb-0 p-3 py-3 rounded-[10px]"
            >
              <div className="overflow-hidden max-h-[400px] min-h-[330px] w-full rounded-xl dark:border-slate-500 items-center flex justify-center">
                <TERipple rippleColor="#aaa">
                  {isVideo(post) ? (
                    <div className="relative">
                      <div style={{ maxWidth: "640px", margin: "auto" }}>
                        <ReactPlayer
                          ref={(player) =>
                            (videoRefs.current[post.uuid] = player)
                          }
                          url={`${APP_STORAGE}gallery_videos/${post.caption_image}`}
                          controls
                          width="100%"
                          height="330px"
                          onPlay={() => handlePlay(post.uuid)}
                        />
                      </div>
                    </div>
                  ) : (
                    <img
                      src={getImageSrc(post)}
                      alt="Display"
                      className="w-full rounded-xl bg-gray-100 dark:bg-slate-700"
                    />
                  )}
                </TERipple>
              </div>

              <div className="flex justify-between gap-2 items-center w-full">
                <div className="flex flex-col">
                  <div className="flex items-center">
                    <div className="text-xl font-semibold capitalize">
                      {post?.user?.username}
                    </div>

                    {/* {post?.user?.badge && (
                      <img
                        src={getBadgeSrc(post.user.badge)}
                        alt={`${post.user.badge} Badge`}
                        className="w-8 h-8"
                      />
                    )} */}
                  </div>

                  <p className="font-normal text-sm">
                    {post?.location?.city}, {post?.location?.state},{" "}
                    {post?.location?.country}
                  </p>
                </div>

                <div>
                  <TERipple rippleColor="#aaa">
                    <button
                      className={`${
                        post?.status !== "accepted"
                          ? "bg-honeConnectPurple"
                          : "bg-[#6A6873]"
                      } py-1 px-5 font-semibold text-xs text-white rounded-[5px]`}
                      onClick={() => {
                        handleConnect(post?.uuid ?? null);
                      }}
                    >
                      Connect
                    </button>
                  </TERipple>
                </div>
              </div>

              <div className="font-medium text-xs text-honeConnectGray dark:text-gray-400 w-full">
                {post?.prespecified_text}
              </div>

              <div className="flex gap-2 w-full">
                <p className="text-xs py-0.5 px-2 border border-solid border-honeConnectGray200 bg-honeConnectGray50 font-normal text-honeConnectGray rounded-sm dark:text-gray-300 dark:bg-slate-800">
                  {post?.interest}
                </p>
              </div>
            </div>,
          );

          // After every 5th item, push an Ad
          if ((index + 1) % 5 === 0) {
            elements.push(
              <div
                key={`ad-${post.uuid}`}
                className="w-full my-4 p-4 text-center rounded-lg shadow"
              >
                {/* Replace with your actual Ad component */}
                <img
                  src={`../sliders/${ads[random_img]}`}
                  alt="Display"
                  className="w-full rounded-xl bg-gray-100 dark:bg-slate-700"
                />
              </div>,
            );
          }
        });
      });

      return elements;
    },
    // eslint-disable-next-line
    [data, ref],
  );

  useEffect(() => {
    if (inView && hasNextPage) fetchNextPage();
  }, [inView, hasNextPage, fetchNextPage]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const direction = prevScrollPos > currentScrollPos ? "up" : "down";
      if (currentScrollPos > 60) {
        setScrollDirection(direction);
      } else {
        setScrollDirection(null);
      }

      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos]);

  if (isLoading && !showModal) {
    return (
      <EliteLayout title="Home">
        <Preloader loading={true} />
      </EliteLayout>
    );
  }

  return (
    <EliteLayout title="Welcome to Elite">
      <div className="grid grid-cols-12 gap-8 justify-between">
        <div className="flex bg-hc_F4EBFA min-h-[100vh] dark:bg-slate-700 border-b border-gray-100 dark:border-slate-800 col-span-12 sm:col-span-7 w-full">
          <div className="flex flex-col w-full">
            <div className="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 mt-28 mb-20 w-full">
              <div
                className={`px-4 shadow flex items-center justify-between w-full bg-white dark:bg-slate-800 border-b dark:border-slate-600 z-10 fixed transition-all duration-500 top-0 ${
                  scrollDirection === null
                    ? "translate-y-[57px]"
                    : scrollDirection === "up"
                      ? "translate-y-0 top-[57px]"
                      : "-translate-y-full"
                }`}
              >
                <TERipple rippleColor="#aaa">
                  <button className="py-3 lg:relative lg:rounded-10px font-medium lg:text-lg lg:p-3 flex gap-1 items-center justify-center">
                    <CiCompass1 className="fa-solid fa-users text-honeConnectPurple dark:text-gray-300 text-xl" />
                    <p className="text-honeConnectBlack dark:text-gray-300 text-xs mt-1">
                      {`${data?.pages[0]?.totalItems ?? "0"} Connect${
                        data?.pages[0]?.totalItems > 1 ? "s" : ""
                      }`}
                    </p>
                  </button>
                </TERipple>

                <TERipple rippleColor="#aaa">
                  <button className="py-3 lg:relative lg:rounded-10px font-medium lg:text-lg lg:p-3 flex gap-1 items-center">
                    <CiMobile1 className="fa-solid fa-users text-honeConnectPurple dark:text-gray-300 text-xl" />
                    <p className="text-honeConnectBlack dark:text-gray-300 text-xs mt-1">
                      {data?.pages[0]?.totalUsers ?? "0"} Users
                    </p>
                  </button>
                </TERipple>

                <TERipple rippleColor="#aaa">
                  <button
                    onClick={() => {
                      setShowModal(true);
                    }}
                    className="py-3 lg:text-lg lg:p-3 flex gap-2 items-center pr-3 font-medium"
                  >
                    <CiSliderHorizontal className="text-2xl text-honeConnectPurple dark:text-gray-300" />
                  </button>
                </TERipple>
              </div>

              <div className="">{connectionComponent}</div>

              {isFetchingNextPage && (
                <div className="flex py-5 pb-16 justify-center">
                  <img
                    src={Loading}
                    alt="loader"
                    className="h-[20px] w-[20px]"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Modal --> */}
      <TEModal show={showModal} onHide={() => setShowModal(false)}>
        <TEModalDialog className="rounded-0 w-full p-2">
          <TEModalContent className="h-[97vh]  dark:bg-slate-800 overflow-scroll rounded-t-md">
            <TEModalHeader className="dark:bg-slate-800 bg-white rounded-t-md px-5">
              {/* <!--Modal title--> */}
              <h5 className="text-md font-medium leading-normal text-honeConnectPurple">
                Filter Results
              </h5>
              {/* <!--Close button--> */}
              <button
                type="button"
                className="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </TEModalHeader>

            {/* <!--Modal body--> */}
            <TEModalBody className="h-[80vh] overflow-scroll">
              <div className="">
                <p className="text-honeConnectBlack dark:text-gray-300 text-xs font-medium mb-3">
                  Filter by Interest
                </p>

                <div className="grid grid-cols-3 xl:grid-cols-3 gap-y-2 items-center mt-2 mb-3">
                  <label className="items-center xl:col-span-1 custom-checkbox">
                    <input
                      type="checkbox"
                      name="interest_id"
                      id="col1"
                      className="h-5 w-5 accent-purple"
                      onChange={() => {
                        handleCheckBox("interest_id", null);
                      }}
                      checked={null === filters.interest_id}
                    />

                    <span className="checkmark"></span>
                    <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                      All
                    </span>
                  </label>

                  {filterInterest(interestData.data).map((item: any) => {
                    return (
                      <label
                        key={item.id}
                        className="items-center xl:col-span-1 custom-checkbox"
                      >
                        <input
                          type="checkbox"
                          name="interest_id"
                          id="col1"
                          className="h-5 w-5 accent-purple"
                          onChange={() => {
                            handleCheckBoxInterest("interest_id", item.id);
                          }}
                          checked={filters.interest_id?.includes(item.id)}
                        />

                        <span className="checkmark"></span>
                        <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium  text-xs">
                          {item.interest}
                        </span>
                      </label>
                    );
                  })}
                </div>
              </div>

              {/* filter by gender */}
              <div className="border-t py-3">
                <p className="text-honeConnectBlack dark:text-gray-300 text-xs font-medium mb-3">
                  Filter by Gender
                </p>

                <div className="grid grid-cols-4 xl:grid-cols-3 gap-y-2 items-center mt-2 mb-1">
                  <label className="items-center xl:col-span-1 custom-checkbox">
                    <input
                      type="checkbox"
                      name=""
                      id="col1"
                      className="h-5 w-5 accent-purple"
                      onChange={() => {
                        handleCheckBox("gender", null);
                      }}
                      checked={null === filters.gender}
                    />
                    <span className="checkmark"></span>
                    <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                      All
                    </span>
                  </label>

                  <label className="items-center xl:col-span-1 custom-checkbox">
                    <input
                      type="checkbox"
                      name=""
                      id="col1"
                      className="h-5 w-5 accent-purple"
                      onChange={() => {
                        handleCheckBox("gender", "OTHERS");
                      }}
                      checked={"OTHERS" === filters.gender}
                    />
                    <span className="checkmark"></span>
                    <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                      Others
                    </span>
                  </label>

                  <label className="items-center xl:col-span-1 custom-checkbox">
                    <input
                      type="checkbox"
                      name=""
                      id="col1"
                      className="h-5 w-5 accent-purple"
                      onChange={() => {
                        handleCheckBox("gender", "MALE");
                      }}
                      checked={"MALE" === filters.gender}
                    />
                    <span className="checkmark"></span>
                    <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                      Male
                    </span>
                  </label>

                  <label className="items-center xl:col-span-1 custom-checkbox">
                    <input
                      type="checkbox"
                      name=""
                      id="col1"
                      className="h-5 w-5 accent-purple"
                      onChange={() => {
                        handleCheckBox("gender", "FEMALE");
                      }}
                      checked={"FEMALE" === filters.gender}
                    />
                    <span className="checkmark"></span>
                    <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                      Female
                    </span>
                  </label>
                </div>
              </div>

              {/* filter by date */}
              <div className="py-3 border-t">
                <p className="text-honeConnectBlack dark:text-gray-400 text-xs font-semibold mb-3">
                  Filter by Date
                </p>

                <div className="grid grid-cols-3 xl:grid-cols-2 gap-y-2">
                  <div className="flex gap-2">
                    <label className="items-center xl:col-span-1 custom-checkbox">
                      <input
                        type="checkbox"
                        name=""
                        id="col1"
                        className="h-5 w-5 accent-purple"
                        onChange={() => {
                          handleCheckBox("date_range", null);
                        }}
                        checked={null === filters.date_range}
                      />
                      <span className="checkmark"></span>
                      <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                        All time
                      </span>
                    </label>
                  </div>

                  <div className="flex gap-2">
                    <label className="items-center xl:col-span-1 custom-checkbox">
                      <input
                        type="checkbox"
                        name=""
                        id="col1"
                        className="h-5 w-5 accent-purple"
                        onChange={() => {
                          handleCheckBox("date_range", 0.5);
                        }}
                        checked={0.5 === filters.date_range}
                      />
                      <span className="checkmark"></span>
                      <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                        Today
                      </span>
                    </label>
                  </div>

                  <div className="flex gap-2">
                    <label className="items-center xl:col-span-1 custom-checkbox">
                      <input
                        type="checkbox"
                        name=""
                        id="col1"
                        className="h-5 w-5 accent-purple"
                        onChange={() => {
                          handleCheckBox("date_range", 7);
                        }}
                        checked={7 === filters.date_range}
                      />
                      <span className="checkmark"></span>
                      <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                        Last 7 days
                      </span>
                    </label>
                  </div>

                  <div className="flex gap-2">
                    <label className="items-center xl:col-span-1 custom-checkbox">
                      <input
                        type="checkbox"
                        name=""
                        id="col1"
                        className="h-5 w-5 accent-purple"
                        onChange={() => {
                          handleCheckBox("date_range", 1);
                        }}
                        checked={1 === filters.date_range}
                      />
                      <span className="checkmark"></span>
                      <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                        Last 24 hours
                      </span>
                    </label>
                  </div>

                  <div className="flex gap-2">
                    <label className="items-center xl:col-span-1 custom-checkbox">
                      <input
                        type="checkbox"
                        name=""
                        id="col1"
                        className="h-5 w-5 accent-purple"
                        onChange={() => {
                          handleCheckBox("date_range", 3);
                        }}
                        checked={3 === filters.date_range}
                      />
                      <span className="checkmark"></span>
                      <span className="text-sm text-honeConnectGray dark:text-gray-400 font-medium text-xs">
                        Last 3 days
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              {/* filter by location */}
              <div className="py-3 border-t grid grid-cols-1 gap-1">
                <div className="flex flex-col w-full mb-1">
                  <label
                    htmlFor="country"
                    className="font-medium dark:text-gray-400 text-xs"
                  >
                    Country
                  </label>
                  <select
                    value={filters.country_id}
                    name="country_id"
                    onChange={handleInputChange}
                    className={`${inputStyle} dark:bg-slate-800 border border-solid border-honeConnectGray200 dark:border-slate-300 text-gray-600  dark:text-gray-300 text-xs`}
                  >
                    <option value="" disabled>
                      Select Country
                    </option>
                    <option value={""}>All Countries</option>
                    {countries?.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-col w-full mb-1">
                  <label
                    htmlFor="state"
                    className="font-medium dark:text-gray-400 text-xs"
                  >
                    State
                  </label>
                  <select
                    value={filters.state_id}
                    name="state_id"
                    onChange={handleInputChange}
                    className={`${inputStyle} dark:bg-slate-800 border border-solid border-honeConnectGray200 dark:border-slate-300 text-gray-600  dark:text-gray-300 text-xs `}
                  >
                    <option value="">Select Country First</option>
                    <option value={""}>All States</option>
                    {states?.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-col w-full">
                  <label
                    htmlFor="city"
                    className="font-medium dark:text-gray-400 text-xs"
                  >
                    City
                  </label>
                  <select
                    value={filters?.city_id}
                    name="city_id"
                    onChange={handleInputChange}
                    className={`${inputStyle} dark:bg-slate-800 border border-solid border-honeConnectGray200 dark:border-slate-300 text-gray-600  dark:text-gray-300 text-xs `}
                  >
                    <option value="">Select State First</option>
                    <option value={""}>All Cities</option>
                    {cities?.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </TEModalBody>

            <TEModalFooter className="flex gap-3">
              <TERipple rippleColor="light" className="">
                <button
                  type="button"
                  className="w-full text-honeConnectPurple dark:text-gray-300 inline-block rounded bg-primary-100 px-6 py-3 text-sm font-medium uppercase leading-normal transition duration-150 ease-in-out hover:bg-primary-accent-100 focus:bg-primary-accent-100 focus:outline-none focus:ring-0 active:bg-primary-accent-200 dark:bg-slate-800  dark:border-slate-400 border"
                  onClick={() => {
                    clearFilter();
                    setShowModal(false);
                  }}
                >
                  Reset
                </button>
              </TERipple>
              <TERipple rippleColor="light" className="w-2/3">
                <button
                  type="button"
                  className="w-full inline-block rounded px-6 py-3 text-sm font-medium uppercase text-gray-500 bg-honeConnectPurple text-white shadow  dark:text-gray-300 border dark:border-slate-600 dark:bg-slate-700"
                  onClick={() => setShowModal(false)}
                >
                  Show {`${data?.pages[0]?.totalItems ?? "0"}`}
                </button>
              </TERipple>
            </TEModalFooter>
          </TEModalContent>
        </TEModalDialog>
      </TEModal>

      {/* <!-- auto - request --> */}
      <TEModal
        show={showAutoRequestModal}
        onHide={() => donotShowAutoRequestModal}
      >
        {/* Flex container that pushes modal content to bottom */}
        <div className="fixed inset-0 flex items-end justify-center z-50">
          <TEModalDialog className="rounded-0 w-full">
            <TEModalContent className="h-[70vh] dark:bg-slate-800 rounded-t-2xl">
              <TEModalHeader className="bg-white dark:bg-slate-800 text-gray-700 px-5 rounded-t-2xl border-b-0">
                <div className="flex justify-end items-end text-end w-full">
                  <button
                    type="button"
                    className="underline box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none text-sm font-medium"
                    onClick={() => donotShowAutoRequestModal()}
                    aria-label="Close"
                  >
                    Skip
                  </button>
                </div>
              </TEModalHeader>

              {/* <!--Modal body--> */}
              <TEModalBody className="pt-0">
                <div className="text-center flex-col justify-center items-center w-full">
                  <div className="flex justify-center items-center text-center mb-1 min-h-[100px]">
                    <img
                      src={SocialConnect}
                      alt="SocialConnect"
                      className="w-3/5"
                    />
                  </div>

                  <h2 className="text-3xl font-semi-bold mb-3 text-gray-600 dark:text-gray-300">
                    Make a request
                  </h2>

                  <p className="text-sm px-4 mb-16 font-medium leading-[1.3] text-gray-600">
                    Make a request to start connecting now
                  </p>

                  <Link
                    to={ELITELINKS.MAKE_REQUEST_AUTOMATIC}
                    className="bg-honeConnectPurple text-white rounded-full px-16 py-4 text-[15px] hover:showdow-sm hover:bg-purple-700"
                  >
                    Continue
                  </Link>
                </div>
              </TEModalBody>
            </TEModalContent>
          </TEModalDialog>
        </div>
      </TEModal>

      <Preloader loading={laoding} />
    </EliteLayout>
  );
};

export default EliteHomePage;
